import { ASSET_META } from "./assets";
import { COMPARE_PAIRS, LEARN_ARTICLES } from "./content";

// Static, build-time discovery index. No external search service, no database.
export const buildIndex = () => ({
  markets: Object.keys(ASSET_META).map((s) => ({
    to: ASSET_META[s].path,
    labelKey: `nav.${s}`,
    raw: s,
  })),
  tools: [
    { to: "/tools/gold-calculator", labelKey: "tools.goldCalc" },
    { to: "/tools/crypto-profit-calculator", labelKey: "tools.cryptoCalc" },
    { to: "/tools/if-you-invested", labelKey: "tools.investCalc" },
    { to: "/tools/currency-converter", labelKey: "tools.converter" },
    { to: "/tools/dca-calculator", labelKey: "x.dcaCalc" },
    { to: "/tools/percentage-change", labelKey: "x.pctCalc" },
    { to: "/tools/investment-return", labelKey: "x.returnCalc" },
  ],
  compare: COMPARE_PAIRS.map((p) => ({ to: `/compare/${p.slug}`, label: p.title })),
  learn: LEARN_ARTICLES.map((a) => ({ to: `/learn/${a.slug}`, label: a.title })),
});
